import classnames from 'classnames';
import * as PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import styles from './Loading.module.scss';

export const SIZES = {
  SM: 'sm',
  MD: 'md',
  LG: 'lg',
};

export default class Loading extends PureComponent {
  static propTypes = {
    hasContainer: PropTypes.bool,
    isLight: PropTypes.bool,
    size: PropTypes.oneOf(Object.values(SIZES)),
    inline: PropTypes.bool,
  };

  static defaultProps = {
    hasContainer: false,
    size: 'md',
  };

  getSizeClass() {
    const { size } = this.props;
    const sizeClassNames = {
      [SIZES.SM]: styles.sm,
      [SIZES.MD]: styles.md,
      [SIZES.LG]: styles.lg,
    };
    return sizeClassNames[size] || styles.md;
  }

  renderLoadingWrapper = () => {
    return <div className={styles.loadingContainer}>{this.renderLoading()}</div>;
  };

  renderLoading = () => {
    const { isLight, inline } = this.props;

    const loadingClasses = classnames(
      {
        [styles.loading]: !isLight,
        [styles.loadingLight]: isLight,
        [styles.inline]: inline,
      },
      this.getSizeClass(),
    );
    return <div className={loadingClasses} />;
  };

  render() {
    const { hasContainer } = this.props;

    return hasContainer ? this.renderLoadingWrapper() : this.renderLoading();
  }
}
